import { Outlet } from "react-router-dom";
import styles from "./index.module.css"
import classNames from "classnames";

export const CenteredLayout = () => {

    return (
        <div className={classNames(styles.centeredLayout, styles.centeredLayoutAnimation)}>
            <div className={styles.authLayoutBg}>
                <img src="/Background_pattern_decorative.webp" />
            </div>
            <div className={styles.centeredContainer}>
                <Outlet />
            </div>
        </div>
    );
}